export var Environment;
(function (Environment) {
  Environment["LOCAL"] = "local";
  Environment["DEV"] = "dev";
  Environment["TEST"] = "test";
  Environment["UAT"] = "uat";
  Environment["PROD"] = "prod";
})(Environment || (Environment = {}));
